import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Common } from '../common';
import { COOKIES_CONSTANTS, LANGUAGE_CODES, LOCAL_STORAGE_CONSTANTS } from '../../config';
import { NavigationService } from './navigation.service';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()
export class SessionService {

  constructor(
    private _router: Router,
    public cookieService: CookieService,
    private navigationService: NavigationService,
    private localStorageService: LocalStorageService
  ) { }

  setCookie(name, value) {
    const timestamp = Common.getCookieExpiredTime();
    this.cookieService.set(name, value, timestamp, '/');
  }

  getCookie(name) {
    if (name == COOKIES_CONSTANTS.langCode) {
      if (this.cookieService.get(COOKIES_CONSTANTS.langCode) == LANGUAGE_CODES.en_US || this.cookieService.get(COOKIES_CONSTANTS.langCode) == LANGUAGE_CODES.es_MX) {
        return this.cookieService.get(name)
      } else {
        return LANGUAGE_CODES.en_US
      }
    }
    else {
      return this.cookieService.get(name);
    }
  }

  deleteCookie(name) {
    this.cookieService.delete(name, '/');
  }

  setSessionItem(name, value) {
    sessionStorage.setItem(name, value);
  }
  setTokenInStorage(result){
    if(result.payload.accessToken){
      this.setSessionItem(COOKIES_CONSTANTS.authToken, result.payload.accessToken)
      this.setCookie(COOKIES_CONSTANTS.authToken, result.payload.accessToken)
    }
    if(result.payload.refreshToken){
      this.setSessionItem(COOKIES_CONSTANTS.refreshToken, result.payload.refreshToken)
      this.setCookie(COOKIES_CONSTANTS.refreshToken, result.payload.refreshToken)
    }
  }

  getSessionItem(name) {
    return sessionStorage.getItem(name);
  }

  removeSessionItem(name) {
    return sessionStorage.removeItem(name);
  }

  removeSession() {
    return sessionStorage.clear();
  }

  setLocalStorageItem(name, value) {
    this.localStorageService.set(name, value);
  }

  getLocalStorageItem(name) {
    return this.localStorageService.get(name);
  }

  removeLocalStorageItem(name) {
    return this.localStorageService.remove(name);
  }

  clearSession() {
    this.deleteCookie(COOKIES_CONSTANTS.authToken);
    this.deleteCookie(COOKIES_CONSTANTS.refreshToken);
    this.deleteCookie(COOKIES_CONSTANTS.name);
    this.deleteCookie(COOKIES_CONSTANTS.archiveMode);
    this.localStorageService.clearAll();
    this.removeSession();
    const langCode = this.getCookie(COOKIES_CONSTANTS.langCode);
    this.setLocalStorageItem(LOCAL_STORAGE_CONSTANTS.langCode, langCode);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/session.service.ts